import React from "react";

const Loader = (props) => {
    return <div className="adjustLoader">
                <span className="spinner-border" role="status"></span>
            </div>
}

export default Loader